import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { formatDate } from '@/utils/format'
import type { MySection } from './api'

/** How the teacher works with a section: class teacher, substitute, and the subjects they teach there. */
export function SectionRoles({ section }: { section: MySection }) {
  const { t } = useTranslation('portal')
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      {section.isClassTeacher ? <Badge tone="brand">{t('Class teacher')}</Badge> : null}
      {section.classCover ? (
        <Badge tone="info">
          {section.classCover.coveringFor
            ? t('Covering for {{name}} until {{date}}', {
                name: section.classCover.coveringFor,
                date: formatDate(section.classCover.endDate),
              })
            : t('Class teacher cover until {{date}}', { date: formatDate(section.classCover.endDate) })}
        </Badge>
      ) : null}
      {section.teaching.map((s) => (
        <span
          key={s.id}
          className="inline-flex items-center gap-1.5 rounded-full border border-line bg-surface px-2.5 py-0.5 text-xs font-medium text-ink-soft"
        >
          <span
            className="size-2 rounded-full"
            style={{ backgroundColor: s.color ?? 'var(--subtle)' }}
            aria-hidden="true"
          />
          {s.name}
          {s.cover ? (
            <span className="text-info-700">
              · {t('cover until {{date}}', { date: formatDate(s.cover.endDate) })}
            </span>
          ) : null}
        </span>
      ))}
    </span>
  )
}
